import { CommandResult, FormApiService } from 'src/common/api-service';
import { AxiosError } from 'axios';
import { CreateBugReport } from './types';

export class BugReportFormApiService extends FormApiService {
  constructor() {
    super('BugReport');
  }

  public async createBugReport(body: CreateBugReport) {
    try {
      return await super.post<CreateBugReport, CommandResult>(body);
    } catch (e) {
      const axiosError = e as AxiosError<CommandResult>;
      if (axiosError?.response?.data == null) throw e;
      return axiosError.response.data;
    }
  }
}
